import backedByLogos from "../assets/BackedBy.png";

const PartnersSection = () => {
  return (
    <section id="partners" className="bg-white py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32 overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8">
        <h2 className="text-center text-2xl sm:text-3xl lg:text-[30px] lg:leading-tight xl:text-[36px] 2xl:text-[clamp(42px,3vw,62px)] font-bold leading-tight text-black max-w-[900px] mx-auto">
          Backed and supported by some of the world&rsquo;s leading tech
          companies
        </h2>

        {/* Desktop: static */}
        <div className="hidden md:block mt-10 md:mt-14 lg:mt-16 xl:mt-20">
          <img
            src={backedByLogos}
            alt="Backed by Mixpanel, NVIDIA Inception Program, Microsoft for Startups Founders Hub, FounderPass, Google for Startups"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>

      {/* Mobile: horizontal scroll */}
      <div className="md:hidden mt-10 overflow-hidden">
        <div className="flex gap-12 w-max animate-scroll-left items-center">
          <img
            src={backedByLogos}
            alt="Backed by Mixpanel, NVIDIA Inception Program, Microsoft for Startups Founders Hub, FounderPass, Google for Startups"
            className="h-[60px] sm:h-[72px] w-auto object-contain shrink-0"
          />
          <img
            src={backedByLogos}
            alt=""
            aria-hidden="true"
            className="h-[60px] sm:h-[72px] w-auto object-contain shrink-0"
          />
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
